function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Link } from "react-router-dom";

class LinkEdit extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(Link, {
        to: this.props.path,
        className: "action-icon"
      }, ' ', /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-pencil"
      }));
    });
  }

}

export default LinkEdit;